import { getResidentialLink } from 'shared/utils/getResidentialLink';

import { useFilters } from './useFilters';

export function useResidentialLink(): string {
  const filters = useFilters();

  return getResidentialLink(filters);
}
